import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class QuestionProgress extends Model<Schemas['questionProgress'], Models> {}
